<template>
  <div>
    <h1 class="text-2xl mb-6">Arbitrage Daily Report</h1>
    <DailyReportFilters ref="dailyReportFilters"></DailyReportFilters>
    <totals></totals>
    <DailyReportTable ref="dailyReportTable"></DailyReportTable>
  </div>
</template>
<script>
import DailyReportTable from "@/components/acquisition/daily-report/tables/DailyReportTable.vue";
import DailyReportFilters from "@/components/acquisition/filters/DailyReportFilters.vue";
import Totals from "@/components/acquisition/daily-report/cards/Totals.vue";
export default {
  name: "ArbitrageDailyReport",
  components: { DailyReportTable, DailyReportFilters, Totals },
};
</script>
<style></style>
